export const ROUTES = {
  LOGIN: "/Login",
  MY_EVENTS: "/MyEvents",
  GROUP_EVENTS: "/GroupEvents",
  EVENT_BOOKING: "/event_booking",
  SHUTTERB_LOGIN: "/Login/shutterb",
  CUSTOMER_LOGIN: "/Login/customer",
  EVENT_THANK_YOU: "/event-thank-you",
  SHUUTERB_DASHBOARD: "/Shutterbdashboard",
  CUSTOMER_DASHBOARD: "/CustomerDashboard",
  MY_EVENTS_TAB: "/CustomerDashboard_/MyEvents",
  CUSTOMER_DASHBOARD_TAB: "/CustomerDashboardTab",
};
